import React from 'react';

import Text from '../../../../../components/shared/Typography/Text';
import s from './index.module.css';

function SafariOverviewHeader({ title = 'Safari Overview' }: { title?: string }) {
  return (
    <div className={s.header}>
      <Text className={s.title} accent>
        {title}
      </Text>
    </div>
  );
}

export default SafariOverviewHeader;
